export const FRONT_PAGE_DE_EMPHASIZE_CTA_EXPERIMENT = {
  frontPageDeEmphasizeCtaExperiment: {
    id: 'reg_1719_front_page-de_emphasize_secondary_cta_experiment',
    variants: {
      VARIANT: 'variant',
    },
  },
};

export const CARDFINDER_TRAVEL_REDIRECT_EXPERIMENT = {
  cardfinderTravelRedirectExperiment: {
    id: 'CCIN-1344_homepage_travel_primary_cta_experiment',
    variants: {
      VARIANT: 'treatment',
    },
  },
};

export const CHATBOT_EXPERIMENT = {
  chatbotExperiment: {
    id: 'cad-975_chatbot_front_page',
    variants: {
      VARIANT: 'treatment',
    },
  },
};

export const EXPERIMENTS = {
  ...FRONT_PAGE_DE_EMPHASIZE_CTA_EXPERIMENT,
  ...CARDFINDER_TRAVEL_REDIRECT_EXPERIMENT,
  ...CHATBOT_EXPERIMENT,
};
